import apiClient from '@/services/axios'

export async function get() {
    console.log("Calling get user Query")
    var response = await apiClient.get(`/UserQuery`)
    if (response) {
        return response.data
    }

    throw new Error('Unable to get user query info')
}
